import React from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Phone, MessageCircle } from 'lucide-react';

const MobileMenu = ({ isOpen, onClose, navigation }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, x: '100%' }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: '100%' }}
          className="fixed inset-0 z-40 bg-white pt-20 lg:hidden overflow-y-auto"
        >
          <div className="px-4 py-6 space-y-4">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={onClose}
                className="block text-lg font-medium text-gray-700 hover:text-primary-teal py-2 border-b border-gray-100"
              >
                {item.name}
              </Link>
            ))}
            
            <div className="pt-6 space-y-4">
              <a href="tel:+919845158507" className="flex items-center justify-center space-x-2 px-4 py-3 border-2 border-primary-teal text-primary-teal rounded-full hover:bg-primary-teal hover:text-white transition-all">
                <Phone className="w-5 h-5" />
                <span>Call Now</span>
              </a>
              <a href="https://wa.me/919845158507" className="flex items-center justify-center space-x-2 px-4 py-3 bg-green-500 text-white rounded-full hover:bg-green-600 transition-all">
                <MessageCircle className="w-5 h-5" />
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileMenu;